import { ActionFunction, redirect } from "react-router-dom";
import { axiosApi } from "../../../interceptors/axios";

export const uploadExamAction: ActionFunction = async ({ request, params }) => {
  const formData = await request.formData();
  const year = formData.get("year");
  const examTypeCode = formData.get("examTypeCode");
  const period = formData.get("period");
  axiosApi.postForm("/api/DusPdf/upload", formData);
  return redirect(`/exams/${examTypeCode}_${year}_${period}/status`); // Redirect to the import page
};
